var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoGrupo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.36,
    height: 118.361,
    viewBox: "0 0 118.36 118.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_46",
    "data-name": "Grupo 46",
    transform: "translate(-252.351 -558.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_43",
    "data-name": "Grupo 43",
    transform: "translate(254.324 560.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_339",
    "data-name": "Trazado 339",
    d: "M373.828,573.45v31.562a3.958,3.958,0,0,1-3.945,3.946H354.1v9.863l-5.918-4.221-7.891-5.641H306.757a3.958,3.958,0,0,1-3.945-3.946V573.45a3.957,3.957,0,0,1,3.945-3.945h63.125A3.957,3.957,0,0,1,373.828,573.45Z",
    transform: "translate(-259.414 -561.614)",
    fill: "#efd2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_39",
    "data-name": "Grupo 39",
    transform: "translate(0 7.891)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_340",
    "data-name": "Trazado 340",
    d: "M367.91,573.45v31.562a3.958,3.958,0,0,1-3.945,3.946H348.183V614.6l-7.891-5.641H306.757a3.958,3.958,0,0,1-3.945-3.946V573.45a3.957,3.957,0,0,1,3.945-3.945h57.207A3.957,3.957,0,0,1,367.91,573.45Z",
    transform: "translate(-259.414 -569.505)",
    fill: "#f1eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_341",
    "data-name": "Trazado 341",
    d: "M376.926,682.311v3.828h-43.4v-3.828a6.565,6.565,0,0,1,3.353-5.7l11.363-6.313a.96.96,0,0,0,.433-.572h13.1a.96.96,0,0,0,.433.572l11.362,6.313A6.566,6.566,0,0,1,376.926,682.311Z",
    transform: "translate(-262.512 -579.614)",
    fill: "#e3e7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_342",
    "data-name": "Trazado 342",
    d: "M280.189,671.5a.916.916,0,0,0,.454.789c1.894,1.164,4.439,2.427,6.313,3.59a23.519,23.519,0,0,1,5.345,3.709,6.645,6.645,0,0,1,1.7,4.38v2.348H254.545V683.97c0-3.157,2.307-5.168,4.754-6.668,2.663-1.618,5.938-3.392,8.6-5.011a.916.916,0,0,0,.454-.789Z",
    transform: "translate(-254.545 -579.793)",
    fill: "#e3e7f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_40",
    "data-name": "Grupo 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_343",
    "data-name": "Trazado 343",
    d: "M291.2,666.666H281.143a.944.944,0,0,0-.848.967v1.006a4.863,4.863,0,0,1-5.069,4.635h-1.7a5.661,5.661,0,0,1-2.11-.414,4.623,4.623,0,0,1-2.959-4.221v-1.006a.939.939,0,0,0-.947-.967h-9.982a1.907,1.907,0,0,1-1.618-2.959,41.222,41.222,0,0,0,5.819-14.085,19.746,19.746,0,0,0,.434-4.162,12.334,12.334,0,0,1,3.57-8.72,11.971,11.971,0,0,1,5.682-3.235,11.249,11.249,0,0,1,2.958-.374,12.132,12.132,0,0,1,8.641,3.609,12.334,12.334,0,0,1,3.57,8.72,19.748,19.748,0,0,0,.434,4.162,41.223,41.223,0,0,0,5.819,14.085,1.915,1.915,0,0,1-1.637,2.959Z",
    transform: "translate(-254.651 -568.032)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_344",
    "data-name": "Trazado 344",
    d: "M325.561,564.674v31.563a3.958,3.958,0,0,1-3.946,3.945H288.08l-13.809,9.863v-9.863H258.49a3.957,3.957,0,0,1-3.945-3.945V564.674a3.957,3.957,0,0,1,3.945-3.945h63.125A3.958,3.958,0,0,1,325.561,564.674Z",
    transform: "translate(-254.545 -560.729)",
    fill: "#efd2ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_345",
    "data-name": "Trazado 345",
    d: "M319.643,564.674v31.563a3.958,3.958,0,0,1-3.945,3.945H282.162l-7.891,5.641v-5.641H258.49a3.957,3.957,0,0,1-3.945-3.945V564.674a3.957,3.957,0,0,1,3.945-3.945H315.7A3.958,3.958,0,0,1,319.643,564.674Z",
    transform: "translate(-254.545 -560.729)",
    fill: "#f1eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_346",
    "data-name": "Trazado 346",
    d: "M368.169,649.148v3.374a3.524,3.524,0,0,1-1.085,2.525,3.536,3.536,0,0,0-1.025,1.855,16.767,16.767,0,0,1-3.018,5.385.943.943,0,0,0-.2.552v2.94a.993.993,0,0,0,.04.256l-6.55,6.549-6.549-6.549a.994.994,0,0,0,.04-.256v-2.94a.946.946,0,0,0-.2-.552,16.778,16.778,0,0,1-3.018-5.385,3.542,3.542,0,0,0-1.025-1.855,3.524,3.524,0,0,1-1.085-2.525v-3.374a3.484,3.484,0,0,1,.395-1.6l.2-.395a3.471,3.471,0,0,0,.395-1.6v-4.833a7.742,7.742,0,0,1,7.891-7.595h5.918a7.742,7.742,0,0,1,7.891,7.595v4.833a3.482,3.482,0,0,0,.395,1.6l.2.395A3.484,3.484,0,0,1,368.169,649.148Z",
    transform: "translate(-263.618 -568.032)",
    fill: "#a4c2f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_41",
    "data-name": "Grupo 41",
    transform: "translate(0.946 65.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_347",
    "data-name": "Trazado 347",
    d: "M285.286,666.708h-9.961a.939.939,0,0,0-.948.967v1.006a4.622,4.622,0,0,1-2.958,4.221,4.623,4.623,0,0,1-2.959-4.221v-1.006a.939.939,0,0,0-.948-.967h-9.981a1.907,1.907,0,0,1-1.618-2.959,41.222,41.222,0,0,0,5.819-14.085,19.746,19.746,0,0,0,.434-4.162,12.334,12.334,0,0,1,3.57-8.72,11.971,11.971,0,0,1,5.682-3.235,11.972,11.972,0,0,1,5.681,3.235,12.334,12.334,0,0,1,3.57,8.72,19.809,19.809,0,0,0,.434,4.162,41.223,41.223,0,0,0,5.819,14.085,1.915,1.915,0,0,1-1.637,2.959Z",
    transform: "translate(-255.597 -633.172)",
    fill: "#d4e1f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_348",
    "data-name": "Trazado 348",
    d: "M362.251,649.148v3.374a3.523,3.523,0,0,1-1.084,2.525,3.543,3.543,0,0,0-1.026,1.855,16.767,16.767,0,0,1-3.018,5.385.949.949,0,0,0-.2.552v2.94a.994.994,0,0,0,.04.256l-3.591,3.59-3.59-3.59a.994.994,0,0,0,.04-.256v-2.94a.946.946,0,0,0-.2-.552,16.778,16.778,0,0,1-3.018-5.385,3.542,3.542,0,0,0-1.025-1.855,3.524,3.524,0,0,1-1.085-2.525v-3.374a3.484,3.484,0,0,1,.395-1.6l.2-.395a3.471,3.471,0,0,0,.395-1.6v-4.833a7.9,7.9,0,0,1,15.782,0v4.833a3.482,3.482,0,0,0,.395,1.6l.2.395A3.484,3.484,0,0,1,362.251,649.148Z",
    transform: "translate(-264.564 -633.13)",
    fill: "#d4e1f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42",
    "data-name": "Grupo 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_349",
    "data-name": "Trazado 349",
    d: "M260.463,683.862c0-3.157,2.307-5.168,4.754-6.668,2.663-1.618,5.938-3.392,8.6-5.011a.913.913,0,0,0,.453-.789.937.937,0,0,0-.947-.967h-5.918a.939.939,0,0,1,.948.967.916.916,0,0,1-.454.789c-2.663,1.618-5.938,3.393-8.6,5.011-2.446,1.5-4.754,3.511-4.754,6.668v2.348h5.918Z",
    transform: "translate(-254.545 -571.794)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_350",
    "data-name": "Trazado 350",
    d: "M258.49,600.183h5.918a3.957,3.957,0,0,1-3.945-3.945V564.674a3.957,3.957,0,0,1,3.945-3.945H258.49a3.957,3.957,0,0,0-3.945,3.945v31.563A3.957,3.957,0,0,0,258.49,600.183Z",
    transform: "translate(-254.545 -560.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_351",
    "data-name": "Trazado 351",
    d: "M342.8,672.919l11.363-6.313a.96.96,0,0,0,.433-.572,1,1,0,0,0,.04-.256v-2.94a.946.946,0,0,0-.2-.552,16.778,16.778,0,0,1-3.018-5.385,3.537,3.537,0,0,0-1.026-1.855,3.526,3.526,0,0,1-1.084-2.525v-3.374a3.473,3.473,0,0,1,.395-1.6l.2-.395a3.482,3.482,0,0,0,.395-1.6v-4.833a7.742,7.742,0,0,1,7.891-7.595h-5.918a7.742,7.742,0,0,0-7.891,7.595v4.833a3.482,3.482,0,0,1-.395,1.6l-.2.395a3.473,3.473,0,0,0-.395,1.6v3.374a3.523,3.523,0,0,0,1.084,2.525A3.543,3.543,0,0,1,345.5,656.9a16.768,16.768,0,0,0,3.018,5.385.949.949,0,0,1,.2.552v2.94a.994.994,0,0,1-.04.256.96.96,0,0,1-.433.572l-11.363,6.313a6.565,6.565,0,0,0-3.353,5.7v3.828h5.917V678.62A6.568,6.568,0,0,1,342.8,672.919Z",
    transform: "translate(-262.512 -568.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_352",
    "data-name": "Trazado 352",
    d: "M312.676,612.5a3.958,3.958,0,0,1-3.945-3.946v-3.944h-5.918v3.945a3.957,3.957,0,0,0,3.945,3.945Z",
    transform: "translate(-259.414 -565.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_353",
    "data-name": "Trazado 353",
    d: "M267.651,649.622a19.807,19.807,0,0,0,.434-4.162,12.334,12.334,0,0,1,3.57-8.72,11.972,11.972,0,0,1,5.674-3.232,12.148,12.148,0,0,0-2.952-.378,11.285,11.285,0,0,0-2.958.375,11.971,11.971,0,0,0-5.682,3.235,12.334,12.334,0,0,0-3.57,8.72,19.746,19.746,0,0,1-.434,4.162,41.222,41.222,0,0,1-5.819,14.085,1.907,1.907,0,0,0,1.618,2.959h5.918a1.907,1.907,0,0,1-1.618-2.959A41.222,41.222,0,0,0,267.651,649.622Z",
    transform: "translate(-254.651 -568.032)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_45",
    "data-name": "Grupo 45",
    transform: "translate(252.351 558.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_354",
    "data-name": "Trazado 354",
    d: "M256.3,565.117V596.68h-3.945V565.117Z",
    transform: "translate(-252.351 -559.199)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_44",
    "data-name": "Grupo 44",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_355",
    "data-name": "Trazado 355",
    d: "M285.02,569.505H265.294a1.973,1.973,0,1,0,0,3.945H285.02a1.973,1.973,0,1,0,0-3.945Z",
    transform: "translate(-253.458 -559.641)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_356",
    "data-name": "Trazado 356",
    d: "M319.681,573.45a1.973,1.973,0,1,0,0-3.945H296.009a1.973,1.973,0,1,0,0,3.945Z",
    transform: "translate(-256.556 -559.641)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_357",
    "data-name": "Trazado 357",
    d: "M265.294,595.39H285.02a1.973,1.973,0,1,0,0-3.945H265.294a1.973,1.973,0,1,0,0,3.945Z",
    transform: "translate(-253.458 -561.855)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_358",
    "data-name": "Trazado 358",
    d: "M319.681,591.445H296.009a1.973,1.973,0,1,0,0,3.945h23.672a1.973,1.973,0,1,0,0-3.945Z",
    transform: "translate(-256.556 -561.855)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_359",
    "data-name": "Trazado 359",
    d: "M280.872,582.448a1.971,1.971,0,0,0,1.973,1.973h35.509a1.973,1.973,0,0,0,0-3.945H282.845a1.971,1.971,0,0,0-1.973,1.973Z",
    transform: "translate(-255.228 -560.748)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_360",
    "data-name": "Trazado 360",
    d: "M367.948,576.087H344.276a1.973,1.973,0,0,0,0,3.945h23.672a1.973,1.973,0,0,0,0-3.945Z",
    transform: "translate(-261.424 -560.305)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_361",
    "data-name": "Trazado 361",
    d: "M367.948,598.027H344.276a1.973,1.973,0,0,0,0,3.945h23.672a1.973,1.973,0,0,0,0-3.945Z",
    transform: "translate(-261.424 -562.518)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_362",
    "data-name": "Trazado 362",
    d: "M367.948,587.057H344.276a1.973,1.973,0,0,0,0,3.945h23.672a1.973,1.973,0,1,0,0-3.945Z",
    transform: "translate(-261.424 -561.412)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_363",
    "data-name": "Trazado 363",
    d: "M265.294,584.42h7.89a1.973,1.973,0,1,0,0-3.945h-7.89a1.973,1.973,0,1,0,0,3.945Z",
    transform: "translate(-253.458 -560.748)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_364",
    "data-name": "Trazado 364",
    d: "M374.311,670.979l-10.823-6.03v-1.98a18.508,18.508,0,0,0,3.177-5.889,1.619,1.619,0,0,1,.459-.84,5.507,5.507,0,0,0,1.691-3.944v-3.371a5.5,5.5,0,0,0-.614-2.509l-.2-.386a1.489,1.489,0,0,1-.17-.688V640.5a9.726,9.726,0,0,0-9.863-9.56h-5.918a9.727,9.727,0,0,0-9.863,9.56v4.848a1.475,1.475,0,0,1-.167.682l-.206.4a5.477,5.477,0,0,0-.613,2.5V652.3a5.517,5.517,0,0,0,1.7,3.947,1.615,1.615,0,0,1,.454.836,18.494,18.494,0,0,0,3.178,5.889v1.98L335.671,671a8.606,8.606,0,0,0-4.338,7.4v3.832a1.974,1.974,0,0,0,1.973,1.973h43.4a1.972,1.972,0,0,0,1.972-1.973v-3.832A8.62,8.62,0,0,0,374.311,670.979ZM345.624,653.4a1.522,1.522,0,0,1-.481-1.1v-3.371a1.5,1.5,0,0,1,.167-.682l.206-.4a5.477,5.477,0,0,0,.613-2.5V640.5a5.778,5.778,0,0,1,5.918-5.614h5.917a5.778,5.778,0,0,1,5.918,5.614v4.848a5.484,5.484,0,0,0,.615,2.509l.2.386a1.51,1.51,0,0,1,.169.688V652.3a1.522,1.522,0,0,1-.481,1.1,5.564,5.564,0,0,0-1.584,2.866,15.228,15.228,0,0,1-2.691,4.633,2.874,2.874,0,0,0-.57,1.716v2.424l-4.537,4.536-4.536-4.536v-2.424a2.893,2.893,0,0,0-.586-1.737,15.189,15.189,0,0,1-2.676-4.613,5.556,5.556,0,0,0-1.583-2.866Zm-10.345,25a4.578,4.578,0,0,1,2.34-3.966l10.7-5.961,4.712,4.712v7.074H335.279v-1.859Zm39.453,1.859H356.978v-7.074l4.713-4.713,10.672,5.944a4.6,4.6,0,0,1,2.369,3.984v1.859Z",
    transform: "translate(-260.318 -565.838)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_365",
    "data-name": "Trazado 365",
    d: "M254.324,684.2h39.453a1.972,1.972,0,0,0,1.973-1.973v-2.343a8.541,8.541,0,0,0-2.2-5.7,17.9,17.9,0,0,0-4.5-3.313c-.429-.251-.855-.5-1.265-.753-.888-.553-1.917-1.127-2.962-1.7h6.059a3.922,3.922,0,0,0,3.495-2.119,3.788,3.788,0,0,0-.253-3.934,39.565,39.565,0,0,1-5.5-13.383,17.935,17.935,0,0,1-.389-3.743,14.274,14.274,0,0,0-4.15-10.1,14.095,14.095,0,0,0-20.069,0,14.274,14.274,0,0,0-4.149,10.1,17.9,17.9,0,0,1-.388,3.733,39.606,39.606,0,0,1-5.5,13.389,3.785,3.785,0,0,0-.258,3.937,3.923,3.923,0,0,0,3.494,2.119h6.2c-.346.2-.7.4-1.046.6-1.487.851-2.973,1.7-4.306,2.509-1.412.855-5.709,3.46-5.709,8.358v2.343a1.972,1.972,0,0,0,1.973,1.973Zm2.88-19.573a43.732,43.732,0,0,0,6.134-14.824,22.051,22.051,0,0,0,.474-4.564,10.345,10.345,0,0,1,3.009-7.326,10.141,10.141,0,0,1,14.46,0,10.342,10.342,0,0,1,3.009,7.326,22.077,22.077,0,0,0,.476,4.574,42.129,42.129,0,0,0,6.119,14.66h-9.971a2.734,2.734,0,0,0-2.873,2.721,2,2,0,0,0-.044.218v1.006a2.908,2.908,0,0,1-3.1,2.662H273.2a2.909,2.909,0,0,1-3.1-2.662v-1.006a1.963,1.963,0,0,0-.042-.214,2.736,2.736,0,0,0-2.874-2.725Zm-.907,15.257c0-1.851,1.175-3.388,3.81-4.984,1.306-.791,2.762-1.624,4.219-2.457.817-.468,1.629-.935,2.422-1.4a7.074,7.074,0,0,0,6.455,3.98H274.9a7.077,7.077,0,0,0,6.471-4.007c.362.2.724.4,1.094.6,1.133.62,2.273,1.244,3.236,1.843.441.276.9.544,1.366.814a14.692,14.692,0,0,1,3.549,2.538,4.6,4.6,0,0,1,1.19,3.067v.37H256.3v-.37Z",
    transform: "translate(-252.351 -565.838)",
    fill: "#264ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_366",
    "data-name": "Trazado 366",
    d: "M254.325,584.42a2.078,2.078,0,0,0,1.4-.572,2,2,0,0,0,0-2.8l-.295-.236a1.481,1.481,0,0,0-.356-.178,1.214,1.214,0,0,0-.355-.118,2.773,2.773,0,0,0-.394-.04,2.07,2.07,0,0,0-1.4.572,1.945,1.945,0,0,0,.65,3.215A1.961,1.961,0,0,0,254.325,584.42Z",
    transform: "translate(-252.352 -560.748)",
    fill: "#7821a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_367",
    "data-name": "Trazado 367",
    d: "M364.793,566.426h-37.48v-1.973a5.925,5.925,0,0,0-5.918-5.918H258.269a5.925,5.925,0,0,0-5.918,5.918v7.891a1.972,1.972,0,1,0,3.944,0v-7.891a1.975,1.975,0,0,1,1.973-1.973h63.125a1.974,1.974,0,0,1,1.973,1.973v31.563a1.973,1.973,0,0,1-1.973,1.973H287.859a1.972,1.972,0,0,0-1.146.368l-10.69,7.635v-6.03a1.971,1.971,0,0,0-1.973-1.973H258.269a1.974,1.974,0,0,1-1.973-1.973v-7.891a1.973,1.973,0,1,0-3.945,0v7.891a5.924,5.924,0,0,0,5.918,5.918h13.808v7.89a1.972,1.972,0,0,0,3.119,1.6l13.295-9.495h7.259v1.972a5.923,5.923,0,0,0,5.918,5.918h32.9l13.294,9.5a1.958,1.958,0,0,0,1.146.368,1.969,1.969,0,0,0,1.973-1.973v-7.891h13.809a5.924,5.924,0,0,0,5.918-5.917V572.344A5.925,5.925,0,0,0,364.793,566.426Zm1.973,37.481a1.975,1.975,0,0,1-1.973,1.973H349.011a1.972,1.972,0,0,0-1.973,1.973v6.03l-10.69-7.635a1.976,1.976,0,0,0-1.146-.369H301.667a1.973,1.973,0,0,1-1.973-1.973v-1.972h21.7a5.925,5.925,0,0,0,5.918-5.918V570.371h37.48a1.975,1.975,0,0,1,1.973,1.973v31.563Z",
    transform: "translate(-252.351 -558.535)",
    fill: "#7821a0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoGrupo);
export default __webpack_public_path__ + "static/media/icono-grupo.83660949350ab3c8f882a860b214aa1f.svg";
export { ForwardRef as ReactComponent };